<template>
  <g>
    <rect class="border"
          :x="x" :y="y" :rx="cellRadius"
          :width="cellWidth" :height="cellHeight"></rect>
    <text class="text" :x="x" :y="y" :dx="txtDx" :dy="txtDy" >{{ text }}</text>
  </g>
</template>

<script>
import { CELL_WIDTH, MINI_CELL_HEIGHT, CELL_RADIUS } from '../grid'

export default {
  name: 'harmap-hole-number',

  props: ['x', 'y', 'text'],

  data () {
    return {
      cellWidth: CELL_WIDTH,
      cellHeight: MINI_CELL_HEIGHT,
      cellRadius: CELL_RADIUS
    }
  },

  computed: {
    txtDx () { return this.cellWidth / 2 },
    txtDy () { return this.cellHeight / 2 }
  }
}
</script>

<style scoped>
.border {
  fill: none;
  stroke: black;
  stroke-width: 2px;
}
.text {
  font-size: 14px;
  text-anchor: middle;
  alignment-baseline: central;
}
</style>



// WEBPACK FOOTER //
// HarmapHoleNumber.vue?6bf4db3e